import api from "@/services/api";
import { Promise } from "core-js";

const BASE_URL = "/audit/activity";

//#region state
const state = {
  listActivity: [],
};
//#endregion

//#region getters
const getters = {};
//#region

//#region actions
const actions = {
  async getActivities(context, params) {
    try {
      const response = await api.get(BASE_URL, params);
      if (response.status === 200) {
        context.commit("SET_LIST_ACTIVITY", response.data);
        return Promise.resolve(response);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
//#endregion

//#region mutations
const mutations = {
  SET_LIST_ACTIVITY(state, payload) {
    state.listActivity = payload;
  },
};
//#endregion

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
